import type { TaxAdvisorRouter } from "@fideus/tax-advisor-api";
import { createTRPCContext } from "@trpc/tanstack-react-query";

export const { TRPCProvider, useTRPC } = createTRPCContext<TaxAdvisorRouter>();
